import initialState from "./agendaAndMeeting.state.js";
import actions from "./agendaAndMeeting.actions.js";
import mutations from "./agendaAndMeeting.mutations.js";
import getters from "./agendaAndMeeting.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
